import React from 'react'

const SummaryItem = props => (
  <p>
    <strong>{props.label}:</strong> {props.children}
  </p>
)
export default SummaryItem



// WEBPACK FOOTER //
// ./src/components/SummaryItem/index.js